export default __webpack_public_path__ + "static/media/zillionAppLoader.1f089619.gif";